








	import Vue from 'vue';
    import _icons from '../../services/icons';

    export default Vue.extend({
        name: "BuildFilterButton",
        props: ['role', 'picked'],
        computed: {
            color: function(): string {
                return this.picked? 'success' : '';
            }
        },
        methods: {
            click: function(): void {
                this.$emit('click', this.role);
            },
            roleIcon: function(role: any): string {
                return _icons.roleIcon(role);
            },
        }
    })
